module.exports = __webpack_public_path__ + "static/media/carenow-bottom-logo.d6116713.jpg";